
import React, { useState } from 'react';
import { Customer } from '../types';

interface CreditTopUpModalProps {
  customer: Customer;
  onClose: () => void;
  onConfirm: (customerId: string, amount: number) => void;
}

const CreditTopUpModal: React.FC<CreditTopUpModalProps> = ({ customer, onClose, onConfirm }) => {
  const [amount, setAmount] = useState<number>(1000);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onConfirm(customer.id, amount);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={onClose}></div>
      <div className="relative bg-white dark:bg-slate-800 rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-6 border-b border-slate-100 dark:border-slate-700">
          <h2 className="text-lg font-black text-slate-900 dark:text-white">Grant AI Credits</h2>
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Manual top-up for <span className="font-bold text-slate-900 dark:text-white">{customer.name}</span></p>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="space-y-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Amount to Add</label>
            <div className="relative">
              <input 
                type="number" 
                autoFocus
                min="1"
                className="w-full pl-4 pr-12 py-3 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl font-bold text-xl text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500"
                value={amount}
                onChange={(e) => setAmount(parseInt(e.target.value) || 0)}
              />
              <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-black text-slate-400 uppercase">Credits</span>
            </div>
          </div>

          <div className="flex gap-2">
            {[500, 1000, 5000].map(val => (
              <button 
                key={val}
                type="button"
                onClick={() => setAmount(val)}
                className={`flex-1 py-2 text-xs font-bold rounded-lg border transition-all ${amount === val ? 'bg-indigo-50 dark:bg-indigo-900/30 border-indigo-200 dark:border-indigo-800 text-indigo-600 dark:text-indigo-400' : 'border-slate-200 dark:border-slate-600 text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700'}`}
              >
                +{val}
              </button>
            ))}
          </div>

          <button 
            type="submit" 
            className="w-full py-3 bg-indigo-600 text-white rounded-xl font-black text-xs uppercase tracking-widest hover:bg-indigo-700 shadow-lg shadow-indigo-100 dark:shadow-none transition-all"
          >
            Confirm Grant
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreditTopUpModal;
